module.exports = __webpack_public_path__ + "static/media/ic_arrow_right_warning.56a9022e.svg";